import { useCallback } from 'react';
import { useAppDispatch } from 'hooks';
import { scheduleDeactivateTeams as _scheduleDeactivateTeams } from 'thunk';
import { OnSuccessV2 } from 'types';
import { DeactivationReason } from '@constants/deactivation';
import { TeamTarget } from 'ProfileModule/types';

export const useScheduleDeactivateTeams = () => {
  const dispatch = useAppDispatch();

  const scheduleDeactivateTeams = useCallback(
    ({
      teamTargets,
      onSuccess,
      dataRetentionDays,
      deactivationReason,
      scheduledArchiveDate,
    }: {
      teamTargets: TeamTarget[];
      onSuccess?: OnSuccessV2;
      dataRetentionDays?: number;
      deactivationReason: DeactivationReason;
      scheduledArchiveDate: string; // yyyy-mm-dd
    }) => {
      dispatch(
        _scheduleDeactivateTeams({
          teamTargets,
          onSuccess,
          dataRetentionDays,
          deactivationReason,
          scheduledArchiveDate,
        }),
      );
    },
    [dispatch],
  );

  return { scheduleDeactivateTeams };
};

export default useScheduleDeactivateTeams;
